import { EsignEnvelopesModal } from "@/pages/esign/widgets/EsignEnvelopesModal.tsx";
import { ProgressBar, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface DocumentEsignProgressBarProps {
  documentId: number;
  documentTitle: string;
  completed: number;
  active: number; // Без cancelled
  total: number; // Все включая cancelled
}

export function DocumentEsignProgressBar({
  documentId,
  documentTitle,
  completed,
  active,
  total,
}: DocumentEsignProgressBarProps) {
  const { t } = useTranslation();
  const { openModal } = useModals();

  return (
    <div
      className="flex h-full min-h-8 w-35 items-center cursor-pointer"
      onClick={() =>
        openModal(EsignEnvelopesModal, {
          documentId,
          documentTitle,
          completedEnvelopesCount: completed,
          activeEnvelopesCount: active,
          totalEnvelopesCount: total,
        })
      }
    >
      <ProgressBar
        completed={completed}
        total={active}
        variant="status"
        className="w-full"
        tooltip={t("core:esign_envelopes_completed_of", { completed, total: active })}
      />
    </div>
  );
}
